
const formList = {
    storageRoomList: [
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        {
            entityField: "stName",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "库房名称",
        },
       
    ],
    cargoOwnerList: [
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        {
            entityField: "coName",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "货主名称",
        },
        {
            entityField: "coCode",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "货主编号",
        },
       
    ],
    carList: [
        // {
        //     entityField: "start",
        //     fieldType: "date",
        //     formatterContent: null,
        //     isRequired: 0,
        //     isShow: 1,
        //     searchId: null,
        //     extractId: null,
        //     setField: null,
        //     showField: "开始时间",
        // },
        // {
        //     entityField: "end",
        //     fieldType: "date",
        //     formatterContent: null,
        //     isRequired: 0,
        //     isShow: 1,
        //     searchId: null,
        //     extractId: null,
        //     setField: null,
        //     showField: "结束时间",
        // },
        {
            entityField: "vmLicensecode",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "车牌号",
        },
        {
            entityField: "searchVmInspectiontime",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: "",
            extractId: null,
            setField: '',
            showField: "年检到期",
        },
       
    ],
   
    
}
export default formList